"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubHeaderType = void 0;
var SubHeaderType;
(function (SubHeaderType) {
    SubHeaderType["TAB_PANEL"] = "tab-panel";
    SubHeaderType["TITLE_BUTTON"] = "title-button";
})(SubHeaderType || (exports.SubHeaderType = SubHeaderType = {}));
